import axios, { AxiosRequestConfig, Method, AxiosInstance } from 'axios';

// Create a custom axios instance
const createHttpClient = (getToken: () => Promise<string>): AxiosInstance => {
    const client = axios.create();

    // Request interceptor to add the bearer token
    client.interceptors.request.use(
        async (config) => {
            try {
                const token = await getToken();
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            } catch (error) {
                console.error('Failed to get token:', error);
                return Promise.reject(error);
            }
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    return client;
};

export const HttpRequest = async <T>(
    httpMethod: string, 
    url: string, 
    payload: any, 
    getToken: () => Promise<string>
) => {
    const client = createHttpClient(getToken);
    
    const config: AxiosRequestConfig = {
        method: httpMethod as Method,
        url,
        data: payload,
        headers: {
            'Accept': 'application/json'
        }
    };
    
    const response = await client.request<T>(config);
    return response.data;
};

// Alternative: Export the client factory for reuse
export { createHttpClient };